import { getCookie } from '../modules/cookie';

const trackConsent = () => {
  const key = 'bjb-consent-submitted';
  const submitted = !!window.localStorage.getItem(key);
  if (!submitted) window.localStorage.setItem(key, '1');

  document.body.dispatchEvent(new CustomEvent('jb-tracking', {
    detail: {
      event: submitted ? 'ce_update_consent' : 'ce_initial_consent',
      analytics: !!getCookie('allow_tracking_cookies'),
      marketing: !!getCookie('allow_marketing_cookies'),
    }
  }));
};

document.addEventListener('jb-cookie-settings:update', trackConsent);
